import React from 'react';
import { motion } from 'framer-motion';
import './ValuesSection.css';

const values = [
  {
    icon: '💡',
    title: 'Innovation',
    description: 'We constantly explore new technologies and approaches to deliver cutting-edge solutions.'
  },
  {
    icon: '🤝',
    title: 'Collaboration',
    description: 'We work closely with our clients to understand their unique needs and challenges.'
  },
  {
    icon: '🎯',
    title: 'Excellence',
    description: 'We are committed to delivering high-quality solutions that exceed expectations.'
  },
  {
    icon: '🔓',
    title: 'Transparency',
    description: 'We maintain open communication throughout the development process.'
  },
  {
    icon: '❤️',
    title: 'Passion',
    description: 'We love what we do and it shows in our work.'
  },
  {
    icon: '🌱',
    title: 'Growth',
    description: 'We help our clients grow and we grow with them.'
  }
];

const ValuesSection = () => {
  return (
    <section className="values-section">
      <div className="container">
        <motion.h2
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Our Core Values
        </motion.h2>
        
        <div className="values-grid">
          {values.map((value, index) => (
            <motion.div
              key={index}
              className="value-card"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="value-icon">{value.icon}</div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;